import { type ParentHeadcountRow, type ChildHeadcountRow } from 'modules/planning/types/headcount'

export const PARENT_NEW_HEADCOUNT = 'new_headcount' as const
export const PARENT_ACTUAL_HEADCOUNT = 'actual_headcount' as const

export const defaultParentRow: ParentHeadcountRow = {
  id: '',
  rowKind: 'parent',
  parentType: PARENT_NEW_HEADCOUNT,
  parentWithChildren: false,
  label: '',
  count: '0',
  salary: '',
  periodCost: '',
  currency: '',
}

export const defaultChildRow: ChildHeadcountRow = {
  id: '',
  rowKind: 'headcount_request',
  parentType: null,
  type: 'new',
  status: null,
  employeeId: '',
  employeeName: '',
  avatarUrl: undefined,
  requestCode: '',
  managerName: '',
  managerAvatarUrl: undefined,
  jobCatalogLabel: '',
  salary: '',
  periodCost: '',
  currency: '',
  workingTime: '',
  workplace: '',
  startDate: '',
  endDate: '',
  jobCatalogTreeNodeUuid: '',
  oldJobCatalogLevelId: '',
  locationId: '',
  managerId: '',
  contractType: null,
  contractTypeLabel: null,
  salaryFrequency: null,
  contractSalaryFrequency: '',
}
